var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "#6D7781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.63,2.26,13,1.64a2.27,2.27,0,0,0-.93-.31h-4a2.27,2.27,0,0,0-.93.31l-.77.62a1.1,1.1,0,0,0-.46.92V7.49a2.69,2.69,0,0,0,.31.77l1.39,1.85a1.36,1.36,0,0,0,1.07.46h2.78A.94.94,0,0,0,12.4,10l1.39-1.84a1.21,1.21,0,0,0,.31-.77V3.18A1.33,1.33,0,0,0,13.63,2.26Zm-.78,5.38-1.4,1.93H8.65L7.08,7.64V3.06l.7-.7h4.37l.7.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.33,14.58v0l-1.08-1.69a.6.6,0,0,0-.59-.37H4.34a.68.68,0,0,0-.48.19l0,0L2.69,14.49l0,.07v0s0,0,0,.05v3.73c0,.19.24.3.66.3s.66-.11.66-.3v-3.5l.78-1.23H15.26L16,14.87v3.5c0,.19.24.3.66.3s.66-.11.66-.3V14.64S17.34,14.6,17.33,14.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f54edf19.svg";
export { ForwardRef as ReactComponent };